export const CATEGORIES = [
  { id: "all", label: "All gatherings" },
  { id: "coffee-tasting", label: "Coffee & conversation" },
  { id: "watch-party", label: "Watch parties" },
  { id: "nature-walk", label: "Nature walks" },
  { id: "elder-getaway", label: "Senior getaways" },
  { id: "lifeskill", label: "Lifeskill building" },
  { id: "other", label: "Other" },
];

export const CATEGORY_LABEL = {
  "coffee-tasting": "Coffee & conversation",
  "watch-party": "Watch parties",
  "nature-walk": "Nature walks",
  "elder-getaway": "Senior getaways",
  "lifeskill": "Lifeskill building",
  "tea-making": "Tea making",
  "supper": "Suppers",
  "other": "Other",
};

export function formatEventDate(iso) {
  try {
    const d = new Date(iso);
    const date = d.toLocaleDateString("en-IN", {
      weekday: "short",
      day: "numeric",
      month: "long",
    });
    const time = d.toLocaleTimeString("en-IN", {
      hour: "numeric",
      minute: "2-digit",
      hour12: true,
    });
    return { date, time };
  } catch {
    return { date: iso, time: "" };
  }
}
